import * as React from 'react';
import styled from 'styled-components';
import { DisplayProps, BackgroundProps, background, color } from 'styled-system';

import { is } from '../../theme/utils';
import ButtonBase from './ButtonBase';
import { ButtonVariant } from './types';
import { applyButtonTheme } from './themes';

type ButtonType = 'button' | 'submit' | 'reset';

export interface ButtonThemeOverrides {
  noShadow: boolean;
  block: boolean;
  background?: BackgroundProps;
  backgroundOnActive?: BackgroundProps;
}

export interface ButtonBaseProps {
  variant: ButtonVariant;
  disabled?: boolean;
}

export const ButtonBaseThemed = styled(ButtonBase)<ButtonProps>`
  ${applyButtonTheme};
  ${background};
  ${color};

  &:active {
    background-color: ${(buttonProps: any) => buttonProps.backgroundOnActive};
  }

  ${is('disabled')`
    cursor:  pointer;
    box-shadow: none;
    &: hover {
      box-shadow: none;
    }
  `}
`;

export interface ButtonProps
  extends Partial<ButtonThemeOverrides>,
    Partial<ButtonBaseProps>,
    DisplayProps,
    React.HTMLAttributes<HTMLButtonElement> {
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  as?: 'button' | 'a';
  href?: string;
  type?: ButtonType;
}

export const Button: React.FC<ButtonProps> = React.forwardRef((props, ref) => {
  const {
    children,
    variant = 'primary',
    block = false,
    noShadow = false,
    type = 'button',
    as = 'button',
    disabled = false,
    ...buttonProps
  } = props;
  return (
    <ButtonBaseThemed
      {...buttonProps}
      ref={ref}
      as={as as any}
      type={type}
      disabled={disabled}
      variant={variant}
      noShadow={noShadow}
      block={block}
    >
      {children}
    </ButtonBaseThemed>
  );
});

Button.displayName = 'Button';
